import { useEffect, useRef } from 'react';
import useChat from '../../hooks/chat/useChat';
import { ChatButton } from './ChatButton';
import { ChatWindow } from './ChatWindow';
import './ProjectChat.scss';

interface Props {
    projectId: number;
    projectTitle: string;
    countryCode?: string;
}

export const ProjectChat = ({ projectId, projectTitle, countryCode }: Props) => {
    const { isOpen, openChat, closeChat } = useChat();
    const hasAutoOpened = useRef(false);

    // Abrir automaticamente al cargar la pagina
    useEffect(() => {
        if (!hasAutoOpened.current) {
            hasAutoOpened.current = true;
            openChat(projectId, projectTitle, countryCode);
        }
    }, [projectId, projectTitle, countryCode, openChat]);

    const handleOpen = () => {
        openChat(projectId, projectTitle, countryCode);
    };

    return (
        <>
            <ChatButton onClick={handleOpen} isOpen={isOpen} />
            {isOpen && (
                <ChatWindow
                    projectTitle={projectTitle}
                    onClose={closeChat}
                />
            )}
        </>
    );
};

export default ProjectChat;
